import { RefObject, useCallback, useEffect, useRef } from 'react';

const useOutsideClickHandler = <T extends HTMLElement>(
  callback: () => void,
  isActive = true
): RefObject<T> => {
  const ref = useRef<T>(null);

  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      if (
        ref.current &&
        !ref.current.contains(event.target as Node) &&
        callback
      ) {
        callback();
      }
    },
    [callback]
  );

  useEffect(() => {
    if (isActive) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside, isActive]); // Add isActive to dependency array

  return ref;
};

export default useOutsideClickHandler;
